export default __webpack_public_path__ + "static/media/arrow_small.e439a309.svg";